<template>
  <div class="course-rank">
    <el-table v-if="courseRankVal != ''" :data="courseRankStudentList" style="width: 100%" height="calc(100vh - 260px)">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-table :data="props.row.courseStudentList" border style="width: 100%; margin: 0 10px;">
            <el-table-column prop="studentName" label="姓名"></el-table-column>
            <el-table-column prop="studentNumber" label="学号"></el-table-column>
            <el-table-column prop="courseScore" label="分数"></el-table-column>
            <!-- <el-table-column prop="rank" label="排名"></el-table-column> -->
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="科目" prop="courseName">
      </el-table-column>
      <!-- <el-table-column label="名次" prop="rank">
      </el-table-column> -->
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <div class="handle-container">
            <el-button type="success" size="small" @click="copyStudentNames(scope.row)">复制名字</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="rank-text" v-else>请输入名次查询</div>
  </div>
</template>

<script>
export default {
  props: ['courseRankVal', 'courseRankStudentList'],
  data() {
    return {
    }
  },
  methods: {
    // 复制名字
    copyStudentNames(row) {
      const names = row.courseStudentList.map(student => student.studentName).join(', ');

      // 如果 navigator.clipboard 存在并且有 writeText 方法，则使用它
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(names).then(() => {
          this.$message.success('学生姓名已复制到剪贴板1');
        }).catch(err => {
          console.error('复制到剪贴板失败', err);
        });
      } else { // 否则使用备用方案
        const tempInput = document.createElement("input");
        tempInput.value = names;
        document.body.appendChild(tempInput);
        tempInput.select();
        try {
          document.execCommand('copy');
          this.$message.success('学生姓名已复制到剪贴板');
        } catch (err) {
          console.error('复制到剪贴板失败', err);
        } finally {
          document.body.removeChild(tempInput);
        }
      }
    },
  }
};
</script>

<style lang="scss" scoped>
@import './courseRank.scss';
</style>